// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-activity__mobile-editors-toolbar{position:relative;display:block;background:#ececec;min-height:40px}.task-activity__mobile-editors-toolbar__body{display:flex;overflow-x:auto}.task-activity__mobile-editors-toolbar__main-editor{flex-shrink:0;flex-grow:1}.task-activity__mobile-editors-toolbar__secondary-editor{flex-shrink:0}.task-activity__mobile-editors-toolbar__secondary-editor .topic-usercontent-mobile{padding-right:0}", ""]);
// Exports
module.exports = exports;
